import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface ReporteHistoricoData {
  inscricaoId: number
  status: string
  reportadoPor: string
  nomeReportador: string | null
  reportadoEm: string
  tipoReportador: string
  justificativaReporte: string | null
  decididoPor: string | null
  nomeDecididor: string | null
  decididoEm: string | null
  justificativaDecisao: string | null
}

export interface ReporteHistoricoDialogInput {
  reportes: ReporteHistoricoData | ReporteHistoricoData[]
  mostrarIndice?: boolean
}

@Component({
  selector: 'app-reporte-historico-dialog',
  templateUrl: './reporte-historico-dialog.component.html',
  styleUrls: ['./reporte-historico-dialog.component.scss'],
})
export class ReporteHistoricoDialogComponent {
  reportes: ReporteHistoricoData[] = []
  mostrarIndice: boolean = false

  constructor(
    public dialogRef: MatDialogRef<ReporteHistoricoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReporteHistoricoDialogInput | ReporteHistoricoData | ReporteHistoricoData[]
  ) {
    if (data && 'reportes' in data) {
      this.reportes = Array.isArray(data.reportes) ? data.reportes : [data.reportes]
      this.mostrarIndice = !!data.mostrarIndice
    } else {
      this.reportes = Array.isArray(data) ? data : [data]
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'PENDENTE': return 'Pendente de decisão'
      case 'DEFERIDA': return 'Deferida — Candidato desclassificado'
      case 'INDEFERIDA': return 'Indeferida — Prova restabelecida'
      default: return status
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'PENDENTE': return 'status-pendente'
      case 'DEFERIDA': return 'status-deferida'
      case 'INDEFERIDA': return 'status-indeferida'
      default: return ''
    }
  }

  getTipoReportadorLabel(tipo: string): string {
    return tipo === 'ADMIN' ? 'Administrador' : 'Examinador'
  }
}
